var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(-18 -571) translate(8 559) translate(8 8)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFFFF",
    fillRule: "nonzero",
    d: "M13.76 4c.73 0 1.43.267 1.975.744l.145.136 1.53 1.53c.334.336.775.541 1.243.582L18.83 7H20c1.054 0 1.918.816 1.995 1.85L22 9v9c0 1.054-.816 1.918-1.85 1.995L20 20H4c-1.054 0-1.918-.816-1.995-1.85L2 18V9c0-1.054.816-1.918 1.85-1.995L4 7h1.17c.474 0 .93-.167 1.29-.47l.13-.12 1.53-1.53c.515-.516 1.199-.825 1.922-.873L10.24 4h3.52zM12 8.31c-2.754 0-4.986 2.233-4.986 4.987S9.246 18.283 12 18.283c2.754 0 4.986-2.232 4.986-4.986 0-2.754-2.232-4.987-4.986-4.987z",
    transform: "translate(-18 -571) translate(8 559) translate(8 8)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.216 13.169L11.009 14.963 14.319 11.658",
    transform: "translate(-18 -571) translate(8 559) translate(8 8)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.ad30b8f0.svg";
export { ForwardRef as ReactComponent };